import {getURLParamsString} from '@/helper';
import RequestService, {METHODS} from '@/services/RequestService';
import {
    IById,
    ICurrentUser,
    IDeleteRemoteAccess,
    IGetUsers,
    IGetUsersAutoComplete,
    IPatchUser,
    IPostRemoteAccess,
    IPostUser,
    PER_PAGE
} from './interfaces';

class UserApi extends RequestService {
    async getCurrentUser({loginParams, _fields, signal}: ICurrentUser) {
        const urlParams = getURLParamsString({...loginParams, _fields});
        return await this.request({url: `/users/me?${urlParams}`, method: METHODS.get, signal});
    }

    async getUsersAutocompletion({search, signal}: IGetUsersAutoComplete) {
        const urlParams = getURLParamsString({
            search,
            per_page: PER_PAGE.autoComplete,
            _fields: ['id', 'partnerId', 'name']
        });
        return await this.request({url: `/users?${urlParams}`, method: METHODS.get, signal});
    }

    async getUsers({page, search, order, orderBy, filters, signal}: IGetUsers) {
        const urlParams = getURLParamsString({
            page,
            search,
            order,
            orderBy,
            ...filters,
            per_page: PER_PAGE.users
        });
        return await this.request({url: `/users?${urlParams}`, method: METHODS.get, signal});
    }

    async getUser({id, signal}: IById) {
        if (!id) throw new Error('User ID is required');
        const urlParams = getURLParamsString({_embed: ['hosts']});
        return await this.request({url: `/users/${id}?${urlParams}`, method: METHODS.get, signal});
    }

    async patchUser({id, data, headers}: IPatchUser) {
        if (!id) throw new Error('User ID is required');
        return await this.request({url: `/users/${id}`, method: METHODS.patch, data, headers});
    }

    async postUser({data, headers}: IPostUser) {
        return await this.request({url: '/users', method: METHODS.post, data, headers});
    }

    async postUserRemoteAccess({id, data}: IPostRemoteAccess) {
        if (!id) throw new Error('User ID is required');
        return await this.request({url: `/users/${id}/remote-access`, method: METHODS.post, data});
    }

    async deleteUserRemoteAccess({id, host}: IDeleteRemoteAccess) {
        if (!id || !host) throw new Error('User ID and Host is required');
        return await this.request({url: `/users/${id}/remote-access/${host}`, method: METHODS.delete});
    }
}

export default new UserApi();
